/**
 * Release notes authoring inside the super admin console.
 *
 * Same component the portal admin sees at /admin/release-notes, mounted with
 * the super admin's API client and `canManage`. Cutting a new release is a
 * platform-wide announcement, so it is a super admin action now; the portal
 * console keeps the list read-only.
 *
 * Enforced server-side by require_super_admin_actor on the POST/PUT/DELETE in
 * app/routers/release_notes.py — GET stays open to every signed-in user because
 * it also backs the user-facing "what's new" feed.
 */
import AdminReleaseNotesPage from "@/pages/AdminReleaseNotes";

import { superAdminApi } from "./session";

export default function SuperAdminReleaseNotesPage() {
  return <AdminReleaseNotesPage client={superAdminApi} canManage />;
}
